import "./stylesheets/index.scss"
import "./stylesheets/tile.sass"

require("./output/Main").main()
